/* ==========================================================
   ParentRecord™ Landing — Shopify Horizon Theme
   File: assets/parentrecord-landing.js

   NOTE VALUTA:
   Il drawer carrello riceve i prezzi via /cart.js, che
   Shopify restituisce già nella valuta di presentazione del
   visitatore (cart.currency, gestita da Shopify Markets).
   formatMoney usa Intl.NumberFormat con quella valuta —
   nessuna API esterna, nessun tasso di cambio gestito a mano.

   NOTA UPSELL:
   COURTWEEK_HANDLE deve corrispondere all'handle reale del
   prodotto "Court Week Calm Protocol" su Shopify (lo trovi
   nell'URL della pagina prodotto, dopo /products/). Se non
   corrisponde, la card upsell non recupera i dati e non
   viene mostrata — nessun errore visibile, va corretto qui.
   ========================================================== */

(function () {
  'use strict';

  var VARIANT_ID = '56837249597764';

  /* ── Upsell config ───────────────────────────────────────── */
  /* Bundle principale ParentRecord: se è nel carrello, mostriamo l'upsell */
  var MAIN_BUNDLE_VARIANT_ID = VARIANT_ID;
  /* Court Week Calm Protocol: se è GIÀ nel carrello, non mostriamo la card */
  var COURTWEEK_VARIANT_ID   = '56859007746372';
  /* Handle del prodotto Court Week, usato per recuperare titolo/immagine/prezzo via /products/{handle}.js */
  var COURTWEEK_HANDLE       = 'court-week-calm-protocol';

  var courtweekProductCache  = null; // popolata al primo bisogno, poi riutilizzata
  var upsellAdding           = false;
  var currentCart            = null;

  /* ── Helpers ─────────────────────────────────────────────── */
  var cartCurrency = 'USD'; // aggiornato al primo fetch di /cart.js

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cartCurrency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      /* Fallback se il browser non supporta narrowSymbol o la currency è invalida */
      return amount.toFixed(2) + ' ' + cartCurrency;
    }
  }

  /* ── Drawer state ────────────────────────────────────────── */
  var drawer       = document.getElementById('prDrawer');
  var overlay      = document.getElementById('prDrawerOverlay');
  var drawerBody   = document.getElementById('prDrawerBody');
  var drawerFooter = document.getElementById('prDrawerFooter');
  var drawerSub    = document.getElementById('prDrawerSubtotal');
  var closeBtn     = document.getElementById('prDrawerClose');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('pr-open');
    overlay.classList.add('pr-open');
    document.body.classList.add('pr-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('pr-open');
    overlay.classList.remove('pr-open');
    document.body.classList.remove('pr-drawer-open');
  }

  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Upsell: helpers ─────────────────────────────────────── */
  function cartHasVariant(cart, variantId) {
    if (!cart.items) return false;
    return cart.items.some(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function fetchCourtweekProduct(callback) {
    if (courtweekProductCache) { callback(courtweekProductCache); return; }
    fetch('/products/' + COURTWEEK_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Product fetch failed'); return r.json(); })
      .then(function (product) {
        courtweekProductCache = product;
        callback(product);
      })
      .catch(function () { callback(null); });
  }

  function renderUpsellCard(cart) {
    var existing = drawerBody.querySelector('.pr-drawer-upsell');
    if (existing) existing.remove();

    var showUpsell = cartHasVariant(cart, MAIN_BUNDLE_VARIANT_ID) && !cartHasVariant(cart, COURTWEEK_VARIANT_ID);
    if (!showUpsell) return;

    fetchCourtweekProduct(function (product) {
      if (!product) return;
      /* Il drawer potrebbe essere stato rirenderizzato nel frattempo (es. quantità cambiata di nuovo) */
      if (drawerBody.querySelector('.pr-drawer-upsell')) return;
      if (!cartHasVariant(currentCart, MAIN_BUNDLE_VARIANT_ID) || cartHasVariant(currentCart, COURTWEEK_VARIANT_ID)) return;

      var variant      = product.variants && product.variants[0];
      var variantId     = variant ? variant.id : COURTWEEK_VARIANT_ID;
      var price         = variant ? variant.price : product.price;
      var comparePrice  = variant ? variant.compare_at_price : product.compare_at_price;
      var image         = product.featured_image || (product.images && product.images[0]) || null;

      var oldPriceHtml = (comparePrice && comparePrice > price)
        ? '<span class="pr-upsell-price-old">' + formatMoney(comparePrice) + '</span>'
        : '';

      var productUrl = '/products/' + COURTWEEK_HANDLE;

      var imgHtml = image
        ? '<a href="' + productUrl + '" class="pr-upsell-img-link"><img class="pr-upsell-img" src="' + image + '" alt="' + product.title + '" loading="lazy"></a>'
        : '<div class="pr-upsell-img-ph"></div>';

      var card = document.createElement('div');
      card.className = 'pr-drawer-upsell';
      card.innerHTML =
        '<div class="pr-upsell-label">Parents preparing for court also add</div>' +
        '<div class="pr-upsell-row">' +
          imgHtml +
          '<div class="pr-upsell-info">' +
            '<a href="' + productUrl + '" class="pr-upsell-title-link"><div class="pr-upsell-title">' + product.title + '</div></a>' +
            '<div class="pr-upsell-sub">7-day planner + court scripts</div>' +
            '<div class="pr-upsell-price">' + oldPriceHtml + formatMoney(price) + '</div>' +
          '</div>' +
          '<button class="pr-upsell-add" type="button" data-variant-id="' + variantId + '">Add +</button>' +
        '</div>';

      drawerBody.appendChild(card);

      card.querySelector('.pr-upsell-add').addEventListener('click', function () {
        if (upsellAdding) return;
        addUpsellToCart(variantId, this);
      });
    });
  }

  function addUpsellToCart(variantId, btn) {
    upsellAdding = true;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      fetchCart(renderCart);
    })
    .catch(function () {
      upsellAdding = false;
      btn.disabled = false;
      btn.textContent = originalText;
    });
  }

  /* ── Render cart items ───────────────────────────────────── */
  function renderCart(cart) {
    if (!drawerBody) return;
    currentCart = cart;
    upsellAdding = false;

    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="pr-drawer-empty">Your cart is empty.<br>Add the bundle to get started.</div>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      updateCartTrigger(cart);
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      /* Bundle principale → homepage; ogni altro prodotto → la sua pagina prodotto */
      var isBundleItem = String(item.variant_id) === String(MAIN_BUNDLE_VARIANT_ID);
      var itemUrl = isBundleItem ? '/' : ('/products/' + item.handle);

      var imgHtml = item.image
        ? '<a href="' + itemUrl + '" class="pr-drawer-item-img-link"><img class="pr-drawer-item-img" src="' + item.image + '" alt="' + item.title + '" loading="lazy"></a>'
        : '<div class="pr-drawer-item-img-ph">No image</div>';

      var originalPrice = item.original_price !== item.final_price
        ? '<span class="pr-drawer-item-price-old">' + formatMoney(item.original_price) + '</span>'
        : '';

      html += '<div class="pr-drawer-item" data-key="' + item.key + '">';
      html += imgHtml;
      html += '<div class="pr-drawer-item-info">';
      html += '<a href="' + itemUrl + '" class="pr-drawer-item-title-link"><div class="pr-drawer-item-title">' + item.product_title + '</div></a>';
      html += '<div class="pr-drawer-item-price">' + originalPrice + formatMoney(item.final_price) + '</div>';
      html += '<div class="pr-drawer-qty-row">';
      html += '<div class="pr-drawer-qty">';
      html += '<button class="pr-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>';
      html += '<span>' + item.quantity + '</span>';
      html += '<button class="pr-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="pr-drawer-remove" data-key="' + item.key + '" data-qty="0">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    drawerBody.innerHTML = html;

    if (drawerSub)    drawerSub.textContent = formatMoney(cart.total_price);
    if (drawerFooter) drawerFooter.style.display = 'block';
    updateCartTrigger(cart);

    /* Qty / remove buttons */
    drawerBody.querySelectorAll('.pr-qty-minus, .pr-qty-plus, .pr-drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        updateItem(key, qty);
      });
    });

    renderUpsellCard(cart);
  }

  /* ── Fetch current cart ──────────────────────────────────── */
  function fetchCart(callback) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.currency) cartCurrency = cart.currency;
        callback(cart);
      })
      .catch(function () {
        if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-empty">Could not load cart. <a href="/cart">View cart</a></div>';
      });
  }

  /* ── Update item quantity ────────────────────────────────── */
  function updateItem(key, quantity) {
    if (drawerBody) drawerBody.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.currency) cartCurrency = cart.currency;
      if (drawerBody) drawerBody.style.opacity = '1';
      renderCart(cart);
    })
    .catch(function () {
      if (drawerBody) drawerBody.style.opacity = '1';
    });
  }

  /* ── Add to cart (then: upsell modal OR redirect OR open drawer) ── */
  function addToCartAndOpen(variantId, btn) {
    var originalText = btn.textContent;
    var skipCart = (window.PR_SKIP_CART !== false); // default true
    var upsellEnabled = !!(window.PR_UPSELL && window.PR_UPSELL.enabled);
    btn.disabled = true;
    btn.textContent = 'Adding…';

    // Only show drawer loading state if we're NOT skipping the cart AND no upsell
    if (!skipCart && !upsellEnabled) {
      if (drawerBody) drawerBody.innerHTML = '<div class="pr-drawer-loading">Loading…</div>';
      if (drawerFooter) drawerFooter.style.display = 'none';
      openDrawer();
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      // Reset button state — modal or redirect takes over
      btn.textContent = originalText;
      btn.disabled = false;

      // Priority 1: upsell modal (if enabled)
      if (upsellEnabled) {
        openUpsellOffer();
        return;
      }
      // Priority 2: skip cart → checkout
      if (skipCart) {
        btn.textContent = '✓ Redirecting…';
        btn.disabled = true;
        btn.style.background = '#1F8A4C';
        window.location.href = '/checkout';
        return;
      }
      // Priority 3: legacy drawer
      fetchCart(renderCart);
      btn.textContent = '✓ Added!';
      btn.style.background = '#1F8A4C';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      if (!skipCart && !upsellEnabled) closeDrawer();
      btn.textContent = originalText;
      btn.disabled = false;
      var fallbackDest = (skipCart || upsellEnabled) ? '/checkout' : '/cart';
      window.location.href = '/cart/' + variantId + ':1?redirect=' + fallbackDest;
    });
  }

  /* ── Mod #27: Upsell modal logic ─────────────────────────── */
  function openUpsellOffer() {
    var m = document.getElementById('prUpsell');
    if (!m) { window.location.href = '/checkout'; return; }
    closeUpsellDetails(); // safety
    m.classList.add('pr-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pr-upsell-open');
  }
  function closeUpsellOffer() {
    var m = document.getElementById('prUpsell');
    if (!m) return;
    m.classList.remove('pr-open');
    m.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.pr-upsell-details.pr-open')) {
      document.body.classList.remove('pr-upsell-open');
    }
  }
  function openUpsellDetails() {
    var m = document.getElementById('prUpsellDetailsModal');
    if (!m) return;
    closeUpsellOffer();
    m.classList.add('pr-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pr-upsell-open');
  }
  function closeUpsellDetails() {
    var m = document.getElementById('prUpsellDetailsModal');
    if (!m) return;
    m.classList.remove('pr-open');
    m.setAttribute('aria-hidden', 'true');
  }

  function upsellGoToCheckout() {
    var skipCart = (window.PR_SKIP_CART !== false); // default true

    if (skipCart) {
      // Mark as redirecting (silent)
      window.location.href = '/checkout';
      return;
    }

    // skip_cart_to_checkout is OFF → decline goes to the cart drawer instead
    closeUpsellOffer();
    closeUpsellDetails();
    fetchCart(renderCart);
    openDrawer();
  }

  function upsellAddAndCheckout(btn) {
    var variantId = btn.getAttribute('data-upsell-variant') ||
                    (window.PR_UPSELL && window.PR_UPSELL.variantId);
    if (!variantId) {
      // No upsell variant configured → just go to checkout
      upsellGoToCheckout();
      return;
    }
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Add failed');
      return r.json();
    })
    .then(function () {
      btn.textContent = '✓ Redirecting…';
      window.location.href = '/checkout';
    })
    .catch(function () {
      // Fallback permalink
      window.location.href = '/cart/' + variantId + ':1?redirect=/checkout';
    });
  }

  function initUpsell() {
    var offer = document.getElementById('prUpsell');
    if (!offer) return; // upsell disabled

    // Any element with [data-pr-upsell-skip] → skip to checkout
    document.querySelectorAll('[data-pr-upsell-skip]').forEach(function (el) {
      el.addEventListener('click', upsellGoToCheckout);
    });

    // Open details on click of upsell name / image
    var detailsTrigger     = document.getElementById('prUpsellDetailsTrigger');
    var detailsNameTrigger = document.getElementById('prUpsellDetailsNameTrigger');
    if (detailsTrigger)     detailsTrigger.addEventListener('click', openUpsellDetails);
    if (detailsNameTrigger) detailsNameTrigger.addEventListener('click', openUpsellDetails);

    // Back from details → re-open offer
    var backBtn = document.getElementById('prUpsellBack');
    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeUpsellDetails();
        openUpsellOffer();
      });
    }

    // Add-to-order buttons (both modals)
    var addBtn        = document.getElementById('prUpsellAdd');
    var addBtnDetails = document.getElementById('prUpsellDetailsAdd');
    if (addBtn)        addBtn.addEventListener('click',        function () { upsellAddAndCheckout(addBtn); });
    if (addBtnDetails) addBtnDetails.addEventListener('click', function () { upsellAddAndCheckout(addBtnDetails); });

    // Escape key closes & goes to checkout
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (offer.classList.contains('pr-open') ||
          (document.getElementById('prUpsellDetailsModal') &&
           document.getElementById('prUpsellDetailsModal').classList.contains('pr-open'))) {
        upsellGoToCheckout();
      }
    });
  }

  /* ── Cart Trigger (floating button) ─────────────────────── */
  function updateCartTrigger(cart) {
    var trigger = document.getElementById('prCartTrigger');
    var badge   = document.getElementById('prCartTriggerBadge');
    if (!trigger) return;
    var count = (cart && cart.item_count) ? cart.item_count : 0;
    if (count > 0) {
      trigger.style.display = 'flex';
      if (badge) badge.textContent = count;
    } else {
      trigger.style.display = 'none';
    }
  }

  function initCartTrigger() {
    var trigger = document.getElementById('prCartTrigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      fetchCart(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    });
    /* Controlla il carrello ad ogni caricamento pagina */
    fetchCart(function (cart) {
      updateCartTrigger(cart);
    });
  }

  /* ── Init CTA buttons ────────────────────────────────────── */
  function initCartButtons() {
    document.querySelectorAll('.pr-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        addToCartAndOpen(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  /* ── Testimonials Carousel ───────────────────────────────── */
  function initCarousel() {
    var track   = document.querySelector('.pr-t-track');
    var cards   = document.querySelectorAll('.pr-t-card');
    var prevBtn = document.querySelector('.pr-t-arrow.pr-t-prev');
    var nextBtn = document.querySelector('.pr-t-arrow.pr-t-next');

    if (!track || !cards.length || !prevBtn || !nextBtn) return;

    var index = 0;

    function visibleCount() { return window.innerWidth > 820 ? 2 : 1; }
    function maxIndex()     { return Math.max(0, cards.length - visibleCount()); }
    function update() {
      var gap       = 24;
      var cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(-' + index * (cardWidth + gap) + 'px)';
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= maxIndex();
    }

    prevBtn.addEventListener('click', function () { if (index > 0)             { index--; update(); } });
    nextBtn.addEventListener('click', function () { if (index < maxIndex())    { index++; update(); } });
    window.addEventListener('resize', function () { if (index > maxIndex()) index = maxIndex(); update(); });
    update();
  }

  /* ── Screenshot Carousels (Mod #6/#7 + #23/#24/#25) ──────── */
  function initScreenshotCarousels() {
    var carousels = document.querySelectorAll('[data-pr-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('.pr-screenshots-track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.pr-screenshots-slide'));
      if (!slides.length) return;

      var dots          = Array.prototype.slice.call(carousel.querySelectorAll('.pr-screenshots-dot'));
      var prevArrow     = carousel.querySelector('.pr-screenshots-arrow-prev');
      var nextArrow     = carousel.querySelector('.pr-screenshots-arrow-next');
      var autoplayMs    = parseInt(carousel.getAttribute('data-pr-autoplay') || '0', 10);
      var loop          = carousel.getAttribute('data-pr-loop') === 'true';
      var hasArrows     = carousel.getAttribute('data-pr-arrows') === 'true';
      var isDouble      = carousel.classList.contains('pr-screenshots--double');
      var visibleCount  = isDouble ? 2 : 1;

      // Build image list for lightbox (originals only — exclude clones)
      var images = slides.map(function (slide) {
        var img = slide.querySelector('img');
        return img ? { src: img.src, alt: img.alt || '' } : null;
      }).filter(Boolean);

      // Click on image → open lightbox
      slides.forEach(function (slide, idx) {
        var img = slide.querySelector('img');
        if (!img) return;
        img.addEventListener('click', function (e) {
          // Skip if this is a clone (added by loop logic)
          if (slide.hasAttribute('data-clone')) {
            // Find original index from clone-of attribute
            var originalIdx = parseInt(slide.getAttribute('data-clone-of') || '0', 10);
            openLightbox(images, originalIdx);
          } else {
            openLightbox(images, idx);
          }
        });
      });

      // ── Loop setup: clone enough slides at end to fill visible count ──
      var clones = [];
      if (loop && slides.length > visibleCount) {
        for (var i = 0; i < visibleCount; i++) {
          var clone = slides[i].cloneNode(true);
          clone.setAttribute('data-clone', 'true');
          clone.setAttribute('data-clone-of', String(i));
          track.appendChild(clone);
          clones.push(clone);
          // Re-attach click handler on clone image too
          (function (idx) {
            var img = clone.querySelector('img');
            if (img) img.addEventListener('click', function () { openLightbox(images, idx); });
          })(i);
        }
      }

      // Hide arrows if not enough slides
      if (hasArrows && slides.length <= visibleCount) {
        if (prevArrow) prevArrow.style.display = 'none';
        if (nextArrow) nextArrow.style.display = 'none';
      }

      // ── Helper: compute step (width of one slide + gap) ──
      function getStep() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      var current = 0;
      var paused  = false;
      var animating = false;

      function scrollToIndex(idx, smooth) {
        var step = getStep();
        track.scrollTo({
          left: step * idx,
          behavior: smooth ? 'smooth' : 'auto'
        });
        // Update dots
        if (dots.length) {
          var realIdx = idx % slides.length;
          dots.forEach(function (dot, i) {
            dot.classList.toggle('pr-active', i === realIdx);
          });
        }
      }

      function next() {
        if (animating) return;
        animating = true;
        current++;
        scrollToIndex(current, true);
        // If we landed on a clone, snap back to real position after animation
        if (loop && current >= slides.length) {
          setTimeout(function () {
            current = 0;
            scrollToIndex(0, false);
            animating = false;
          }, 550);
        } else {
          setTimeout(function () { animating = false; }, 550);
        }
      }

      function prev() {
        if (animating) return;
        animating = true;
        if (current <= 0) {
          if (loop) {
            // Jump silently to clone-equivalent at the end, then animate back
            current = slides.length;
            scrollToIndex(current, false);
            setTimeout(function () {
              current = slides.length - 1;
              scrollToIndex(current, true);
              setTimeout(function () { animating = false; }, 550);
            }, 30);
          } else {
            animating = false;
          }
        } else {
          current--;
          scrollToIndex(current, true);
          setTimeout(function () { animating = false; }, 550);
        }
      }

      // Mark first dot active
      if (dots.length) dots[0].classList.add('pr-active');

      // ── Arrows ──
      if (prevArrow) prevArrow.addEventListener('click', function () { pauseTemporarily(); prev(); });
      if (nextArrow) nextArrow.addEventListener('click', function () { pauseTemporarily(); next(); });

      // ── Dots click ──
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          pauseTemporarily();
          current = i;
          scrollToIndex(current, true);
        });
      });

      // ── Autoplay ──
      var autoplayTimer = null;
      function startAutoplay() {
        if (!autoplayMs) return;
        if (autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = setInterval(function () {
          if (!paused) next();
        }, autoplayMs);
      }
      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      var resumeTimer = null;
      function pauseTemporarily() {
        paused = true;
        carousel.classList.add('pr-paused');
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          paused = false;
          carousel.classList.remove('pr-paused');
        }, Math.max(autoplayMs * 1.5, 4000));
      }

      if (autoplayMs > 0) {
        startAutoplay();
        // Pause on hover (desktop)
        carousel.addEventListener('mouseenter', function () { paused = true; });
        carousel.addEventListener('mouseleave', function () { paused = false; });
        // Pause on touch (mobile)
        carousel.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        carousel.addEventListener('touchend',   function () {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () { paused = false; }, 3500);
        }, { passive: true });
        // Pause when tab hidden
        document.addEventListener('visibilitychange', function () {
          paused = document.hidden;
        });
      }

      // ── Manual scroll sync (user swipes) → update dots only ──
      if (dots.length && !loop) {
        var scrollTimer = null;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var step = getStep();
            var idx = Math.round(track.scrollLeft / step);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('pr-active', i === (idx % slides.length));
            });
            current = idx;
          }, 120);
        });
      }
    });
  }

  /* ── Mod #17: Lightbox ───────────────────────────────────── */
  var lightboxState = { images: [], index: 0 };

  function openLightbox(images, startIdx) {
    var lb = document.getElementById('prLightbox');
    if (!lb || !images || !images.length) return;
    lightboxState.images = images;
    lightboxState.index = startIdx || 0;
    renderLightbox();
    lb.classList.add('pr-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pr-lightbox-open');
  }

  function closeLightbox() {
    var lb = document.getElementById('prLightbox');
    if (!lb) return;
    lb.classList.remove('pr-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pr-lightbox-open');
  }

  function renderLightbox() {
    var img = document.getElementById('prLightboxImg');
    var counter = document.getElementById('prLightboxCounter');
    var prevBtn = document.getElementById('prLightboxPrev');
    var nextBtn = document.getElementById('prLightboxNext');
    if (!img) return;
    var current = lightboxState.images[lightboxState.index];
    if (!current) return;
    img.src = current.src;
    img.alt = current.alt;
    var total = lightboxState.images.length;
    if (counter) counter.textContent = (lightboxState.index + 1) + ' / ' + total;
    // Hide nav buttons if only one image
    if (prevBtn) prevBtn.style.display = total > 1 ? '' : 'none';
    if (nextBtn) nextBtn.style.display = total > 1 ? '' : 'none';
  }

  function lightboxPrev() {
    var total = lightboxState.images.length;
    if (total < 2) return;
    lightboxState.index = (lightboxState.index - 1 + total) % total;
    renderLightbox();
  }
  function lightboxNext() {
    var total = lightboxState.images.length;
    if (total < 2) return;
    lightboxState.index = (lightboxState.index + 1) % total;
    renderLightbox();
  }

  function initLightbox() {
    var lb = document.getElementById('prLightbox');
    if (!lb) return;
    var closeBtn = document.getElementById('prLightboxClose');
    var prevBtn  = document.getElementById('prLightboxPrev');
    var nextBtn  = document.getElementById('prLightboxNext');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', lightboxPrev);
    if (nextBtn) nextBtn.addEventListener('click', lightboxNext);
    // Click on overlay (but not inner image) closes
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('pr-lightbox-stage')) {
        closeLightbox();
      }
    });
    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('pr-open')) return;
      if (e.key === 'Escape')      closeLightbox();
      else if (e.key === 'ArrowLeft')  lightboxPrev();
      else if (e.key === 'ArrowRight') lightboxNext();
    });
    // Swipe gestures on mobile
    var touchStartX = 0;
    var touchEndX   = 0;
    lb.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var dx = touchEndX - touchStartX;
      if (Math.abs(dx) < 50) return;
      if (dx > 0) lightboxPrev();
      else        lightboxNext();
    }, { passive: true });
  }

  /* ── Smooth anchor scrolling ─────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('.pr-landing a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.getElementById(this.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Fade-in on scroll ───────────────────────────────────── */
  function initFadeIn() {
    if (!window.IntersectionObserver) return;
    var style = document.createElement('style');
    style.textContent = [
      '.pr-fade-target { opacity:0; transform:translateY(24px); transition:opacity .55s ease,transform .55s ease; }',
      '.pr-fade-target.pr-visible { opacity:1; transform:translateY(0); }'
    ].join('');
    document.head.appendChild(style);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('pr-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.pr-landing section').forEach(function (s) {
      s.classList.add('pr-fade-target');
      observer.observe(s);
    });

    var hero = document.querySelector('.pr-hero');
    if (hero) { hero.classList.add('pr-visible'); hero.style.opacity = '1'; hero.style.transform = 'none'; }
  }

  /* ── Social Proof Popup ──────────────────────────────────── */
  function initSocialPopup() {
    var popup     = document.getElementById('prPopup');
    var popupName = document.getElementById('prPopupName');
    var popupTime = document.getElementById('prPopupTime');
    var popupAvatar = document.getElementById('prPopupAvatar');
    var popupClose  = document.getElementById('prPopupClose');

    if (!popup) return;

    var names = [
      'Ashley M.', 'Jennifer R.', 'Sarah K.', 'Amanda L.', 'Jessica T.',
      'Stephanie H.', 'Michelle W.', 'Lisa B.', 'Angela C.', 'Melissa D.',
      'Lauren P.', 'Rachel N.', 'Megan S.', 'Christina F.', 'Brittany G.',
      'Nicole A.', 'Heather J.', 'Amber V.', 'Tiffany O.', 'Danielle E.'
    ];

    var states = [
      'California', 'Texas', 'Florida', 'New York', 'Ohio',
      'Georgia', 'Pennsylvania', 'Illinois', 'Arizona', 'Colorado',
      'Michigan', 'Virginia', 'Washington', 'Tennessee', 'Oregon'
    ];

    /* Soft pastel-on-dark avatar colors */
    var colors = [
      '#1755B8', '#0E6655', '#7D3C98', '#B03A2E',
      '#1A5276', '#117A65', '#6E2F8F', '#935116'
    ];

    var lastIndex = -1;
    var hideTimer = null;
    var nextTimer = null;
    var dismissed = false;

    function rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function randomTime() {
      var mins = rand(1, 47);
      if (mins === 1) return 'just now';
      if (mins < 60) return mins + ' minutes ago';
      var hrs = Math.floor(mins / 60);
      return hrs === 1 ? '1 hour ago' : hrs + ' hours ago';
    }

    function pickIndex() {
      var i;
      do { i = rand(0, names.length - 1); } while (i === lastIndex);
      lastIndex = i;
      return i;
    }

    function showPopup() {
      if (dismissed) return;

      var i      = pickIndex();
      var name   = names[i];
      var state  = states[rand(0, states.length - 1)];
      var color  = colors[rand(0, colors.length - 1)];
      var initials = name.charAt(0);

      popupAvatar.textContent    = initials;
      popupAvatar.style.background = color;
      popupName.textContent      = name + ' from ' + state;
      popupTime.textContent      = randomTime();

      popup.classList.remove('pr-popup-hiding');
      popup.classList.add('pr-popup-visible');

      /* Hide after 3s */
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        hidePopup();
      }, 3000);
    }

    function hidePopup() {
      popup.classList.add('pr-popup-hiding');
      popup.classList.remove('pr-popup-visible');

      /* Schedule next appearance: random between 8 and 20 seconds */
      clearTimeout(nextTimer);
      nextTimer = setTimeout(function () {
        popup.classList.remove('pr-popup-hiding');
        showPopup();
      }, rand(8000, 20000));
    }

    /* Close button dismisses for the session */
    if (popupClose) {
      popupClose.addEventListener('click', function () {
        dismissed = true;
        clearTimeout(hideTimer);
        clearTimeout(nextTimer);
        popup.classList.add('pr-popup-hiding');
        popup.classList.remove('pr-popup-visible');
      });
    }

    /* First appearance after 4 seconds */
    setTimeout(showPopup, 4000);
  }

  /* ── Init ────────────────────────────────────────────────── */
  /* ── Bonus Card Carousel — dots only (scroll-snap does the rest) ── */
  function initBonusCardCarousel() {
    var wrap = document.querySelector('.pr-bonus-card-carousel');
    if (!wrap) return;
    var track = wrap.querySelector('.pr-bonus-card-track');
    var dots  = wrap.querySelectorAll('.pr-bonus-card-dots .pr-screenshots-dot');
    if (!track || !dots.length) return;

    // Dot click → scroll to card
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var cards = track.querySelectorAll('.pr-bonus-card');
        var card  = cards[i];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      });
    });

    // Update active dot on scroll
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var cards = track.querySelectorAll('.pr-bonus-card');
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('pr-active', i === idx);
        });
      }, 80);
    });
  }

  function init() {
    initCartTrigger();
    initCartButtons();
    initCarousel();
    initScreenshotCarousels();
    initBonusCardCarousel();
    initLightbox();
    initUpsell();
    initSmoothScroll();
    initFadeIn();
    initSocialPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
